import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';

export const versionApi = createApi({
  reducerPath: 'versionApi',
  baseQuery,
  endpoints: (builder) => ({
    // Backend build / git information
    getFullVersionInfo: builder.query({
      query: () => '/version/fullVersionInfo',
    }),
  }),
});

export const { useGetFullVersionInfoQuery } = versionApi;
